import React from 'react';
import { useField, useForm } from 'react-final-form';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { FormWrapper } from 'ksnm-common-ui/lib/Form/FormWrapper';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { RangeDateField } from 'ksnm-common-ui/lib/Form/RangeDateField';
import { debounce } from 'lodash-es';

import { logsStore } from '@stores/logsStore';

import styles from '../Logs.module.scss';

export const Form = observer(() => {
  const { submit } = useForm();

  const debouncedInput = debounce(() => {
    submit();
  }, 300);

  const {
    input: { value },
  } = useField('guid');

  return (
    <div className={styles.filter}>
      <RangeDateField nameStart="dateFrom" nameFinish="dateTo" size="small" onChange={debouncedInput} />
      <TextField
        name="guid"
        placeholder="Поиск по идентификатору процесса"
        onChange={debouncedInput}
        size="small"
        allowClear
        className={cm({ [styles.input]: value })}
      />
    </div>
  );
});

export const Filter = observer(() => {
  const { setFilterValues, filterValues } = logsStore;

  const onSubmit = React.useCallback(
    (values) => {
      setFilterValues({ dateFrom: values.dateFrom, dateTo: values.dateTo, guid: values.guid });
    },
    [setFilterValues],
  );

  return (
    <FormWrapper onSubmit={onSubmit} initialValues={filterValues}>
      <Form />
    </FormWrapper>
  );
});
